import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  makeStyles
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: '#ffffff'
  },
  card: {
    maxWidth: '100%',
    padding: '20px',
    textAlign: 'center',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
    fontFamily: "'Poppins', sans-serif"
  },
  qrCode: {
    margin: '20px auto'
  },
  button: {
    marginTop: '20px',
    fontFamily: "'Poppins', sans-serif"
  }
}));

const SetupPassword = () => {
  const classes = useStyles();
  const [searchParams] = useSearchParams();
  const username = searchParams.get('username');
  const resetLink = searchParams.get('link');

  return (
    <Container className={classes.container}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            Complete Your Setup
          </Typography>
          <Typography variant="body1" gutterBottom>
            Hello <strong>{username}</strong>, to complete your registration,
            please set up your password by clicking the link below:
          </Typography>
          <img
            src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(
              resetLink
            )}`}
            alt="QR Code"
            className={classes.qrCode}
          />
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {resetLink}
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            variant="contained"
            color="primary"
            href={resetLink}
            target="_blank"
            fullWidth
            className={classes.button}
          >
            Set Up Password
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
};

export default SetupPassword;
